import client from "./client";

export const negotiateOffer = (sessionId: string, clientId: string, counterOffer: number) =>
  client.post(
    `/client/${clientId}/session/${sessionId}/offer/negotiate`,
    {
      counterOffer,
    },
    {
      headers: { session_id: sessionId },
    }
  );
